import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import React from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { useDialogContentClassName } from './utils/useDialogContentClassName';
import { DialogContentRoot } from './style';
import { dialogContentDefaultTheme } from './theme';
import { DIALOG_CONTENT_CLASS_PREFIX } from './constants';
var CLASS_PREFIX = 'DialogContent';
export var DialogContent = function DialogContent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(DIALOG_CONTENT_CLASS_PREFIX, dialogContentDefaultTheme);
  var classNameRoot = useDialogContentClassName(CLASS_PREFIX, className);
  return React.createElement(DialogContentRoot, Object.assign({}, restProps, {
    theme: theme,
    className: classNameRoot
  }), children);
};
DialogContent.defaultProps = {
  enableVerticalScroll: true
};